/**
 * A carreira, em português.
 *
 * Só entra aqui o que dá para conferir: app na loja, jogo publicado,
 * estratégia no marketplace, curso concluído. Sem adjetivo e sem "ajudei
 * a entregar" — quem lê quer saber o que existe e onde ver.
 */

export type MilestoneCategory = "now" | "role" | "project" | "education";

export interface Milestone {
  id: string;
  /** Ano ou faixa. "2026 →" para o que está em andamento. */
  year?: string;
  title: string;
  category: MilestoneCategory;
  body: string;
  tags?: readonly string[];
  link?: string;
}

export const TIMELINE: readonly Milestone[] = [
  {
    id: "jgson",
    year: "2026 →",
    title: "JGson, estúdio de uma pessoa só",
    category: "now",
    body: "Cypher Bot, este site e trabalho para clientes. Tudo começa por uma especificação escrita, nasce pensado no celular e passa por auditoria de acessibilidade antes de subir.",
    tags: ["Fundador", "Spec-kit", "Cloudflare"],
  },
  {
    id: "tonic3",
    year: "Atual",
    title: "Tonic3, engenheiro mobile sênior",
    category: "role",
    body: "Engenharia guiada por experiência de uso, entre aplicativo e tecnologia imersiva. A Tonic3 é a divisão de UX da W3, em Dallas.",
    tags: ["Mobile", "UX", "Realidade aumentada"],
    link: "https://www.tonic3.com",
  },
  {
    id: "magic-puzzle-quest",
    year: "2019",
    title: "Magic: Puzzle Quest",
    category: "project",
    body: "Jogo de combinar peças com RPG na marca Magic: The Gathering, da Wizards of the Coast. Desenvolvedor Unity na Oktagon Games, publicado pela D3 Publisher, para iOS e Android.",
    tags: ["Unity", "C#", "iOS", "Android"],
    link: "https://play.google.com/store/apps/details?id=com.d3p.olympic",
  },
  {
    id: "doodle-jump-adventure",
    year: "2019",
    title: "Doodle Jump Adventure",
    category: "project",
    body: "Jogo de pulo da franquia Doodle Jump, da Lima Sky. Desenvolvedor Unity na Oktagon Games. Saiu das lojas oficiais e continua listado no QooApp.",
    tags: ["Unity", "C#", "Lima Sky"],
    link: "https://m-apps.qoo-app.com/en-US/app/10205",
  },
  {
    id: "nelogica-atr-ema",
    year: "2025",
    title: "ATR Trailing Stop com EMA",
    category: "project",
    body: "Indicador e estratégia publicados no marketplace do Profit Pro, da Nelogica. Sensibilidade ajustável, suavização opcional por Heikin Ashi, coloração das barras no gatilho e alertas em tempo real.",
    tags: ["NTSL", "Profit Pro", "Nelogica"],
    link: "https://nelogica.com.br/estrategias?id=10748",
  },
  {
    id: "cypher-bot",
    title: "Cypher Bot",
    category: "project",
    body: "Plataforma de automação para quem opera no mercado: regras automáticas, integração com dados de mercado e interface de terminal. Em construção.",
    tags: ["SaaS", "Fintech", "Automação"],
    link: "https://app.cypher-bot.com",
  },
  {
    id: "guia-guine",
    title: "Guia Guiné",
    category: "project",
    body: "Aplicativo de guia publicado na Google Play, lançamento independente do JGson.",
    tags: ["Android", "Play Store"],
    link: "https://play.google.com/store/apps/details?id=com.jgson.guiaguine",
  },
  {
    id: "puc-pr-pos",
    title: "PUC-PR, pós-graduação",
    category: "education",
    body: "Arquitetura de Software e Cybersegurança, na Pontifícia Universidade Católica do Paraná.",
    tags: ["Arquitetura", "Segurança"],
  },
];

export const CATEGORY_LABELS: Record<MilestoneCategory, string> = {
  now: "Agora",
  role: "Onde trabalho",
  project: "O que publiquei",
  education: "Formação",
};

export const CATEGORY_ORDER: readonly MilestoneCategory[] = [
  "now",
  "role",
  "project",
  "education",
];

export function groupByCategory(
  timeline: readonly Milestone[],
): Record<MilestoneCategory, Milestone[]> {
  const out: Record<MilestoneCategory, Milestone[]> = {
    now: [],
    role: [],
    project: [],
    education: [],
  };
  for (const m of timeline) out[m.category].push(m);
  return out;
}
